module.exports = "../../../../platform/assets/pageMainIcon/jichudanganlei5.svg";